import type { BookingFieldViolation } from "@freightsimple/generated-dashboard-openapi-client/models/BookingFieldViolation";
import { Banner } from "@freightsimple/ui-core/Display/Banner";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";

interface BookShipmentBookingRefusedBannerProps {
  /** Why the server refused the last Book attempt, one entry per field. */
  violations: BookingFieldViolation[];
}

/**
 * Shown on Review when the server refused to book because the shipment is not
 * ready (a contact phone, a deadline on or before the pickup date). These are
 * the customer's to fix, so they stay on this screen with the reasons instead
 * of being sent to "Nearly there", which is for failures only we can finish.
 */
export function BookShipmentBookingRefusedBanner({
  violations,
}: BookShipmentBookingRefusedBannerProps) {
  return (
    <Banner variant="danger" title="This shipment can't be booked yet">
      <Stack gap={1} align="start">
        {violations.map((violation) => (
          <T key={violation.field} size="sm">
            {violation.message}
          </T>
        ))}
        <T size="sm">
          Use the Modify links in the shipment summary to fix them, then book
          again.
        </T>
      </Stack>
    </Banner>
  );
}
